module.exports = __webpack_public_path__ + "img/icb-opening-06.34d73377.png";